module.exports = __webpack_public_path__ + "img/kz.fb346a50.png";